import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.promise";
import _slicedToArray2 from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/KB-PGR-JOB1/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/KB-PGR-JOB1/gatsby/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React__default, { useContext, useEffect, useState, useRef, useMemo, createElement, Component, createContext } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
/* eslint-disable react/no-danger */

var BodyTrackingScripts = function BodyTrackingScripts(_ref) {
  var environment = _ref.environment;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||\"https:\"===document.location.protocol,a=document.createElement(\"script\");a.type=\"text/javascript\",a.async=!0,a.src=(r?\"https:\":\"http:\")+\"//cdn.heapanalytics.com/js/heap-\"+e+\".js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=[\"addEventProperties\",\"addUserProperties\",\"clearEventProperties\",\"identify\",\"resetIdentity\",\"removeEventProperty\",\"setEventProperties\",\"track\",\"unsetEventProperty\"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};\nif(window.location.hostname === \"www.kabbage.com\") {\n  heap.load(\"177207642\");\n}else{\n  heap.load(\"4051235984\");\n}"
    }
  }), React__default.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "var getUrlParameter = function getUrlParameter(sParam) {\n  var sPageURL = window.location.search.substring(1),\n    sURLVariables = sPageURL.split('&'),\n    sParameterName,\n    i;\n  for (i = 0; i < sURLVariables.length; i++) {\n    sParameterName = sURLVariables[i].split('=');\n    if (sParameterName[0] === sParam) {\n        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);\n    }\n  }\n};\n\ndocument.addEventListener(\"DOMContentLoaded\", function() {\n  function getCookie(cname) {\n    var name = cname + \"=\";\n    var decodedCookie = decodeURIComponent(document.cookie);\n    var ca = decodedCookie.split(';');\n    for(var i = 0; i <ca.length; i++) {\n      var c = ca[i];\n      while (c.charAt(0) == ' ') {\n        c = c.substring(1);\n      }\n      if (c.indexOf(name) == 0) {\n        return c.substring(name.length, c.length);\n      }\n    }\n    return \"\";\n  }\n  var tid = getCookie('__k_tid');\n  if (tid != undefined) {\n      ga('set', 'dimension9', tid);\n  }\n  var rid = getUrlParameter('refid');\n  if(rid != undefined){\n    ga('set', 'dimension4', rid)\n  }\n});"
    }
  }));
};

BodyTrackingScripts.propTypes = {
  environment: PropTypes.string
};
BodyTrackingScripts.defaultProps = {
  environment: ''
};
/* eslint-disable react/no-danger */

var HeadTrackingScripts = function HeadTrackingScripts() {
  return React__default.createElement(Helmet, null, React__default.createElement("link", {
    rel: "preload",
    href: "//cdn.optimizely.com/js/17445442224.js",
    as: "script"
  }), React__default.createElement("link", {
    rel: "preconnect",
    href: "//logx.optimizely.com"
  }), React__default.createElement("script", {
    src: "https://cdn.optimizely.com/js/17445442224.js"
  }), React__default.createElement("script", null, "(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;\nh.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};\n(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;\n})(window,document.documentElement,'async-hide','dataLayer',4000,\n{'GTM-NPF27MS':true});"), React__default.createElement("script", null, "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\nm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\nga('create', 'UA-11074577-1', 'auto');\nga('require', 'GTM-NPF27MS');\nga('send', 'pageview');"), React__default.createElement("script", {
    type: "text/javascript"
  }, "(function(a,b,c,d){\nvar a = '//cdn.heapanalytics.com/js/heap-4051235984.js';\nif(window.location.hostname === \"www.kabbage.com\") {\na = '//cdn.heapanalytics.com/js/heap-177207642.js'; }\nb=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;\na=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);\n})();"));
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return decodeURIComponent(components.join(''));
  } catch (err) {// Do nothing
  }

  if (components.length === 1) {
    return components;
  }

  split = split || 1; // Split the array in 2 parts

  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher);

    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher);
    }

    return input;
  }
}

function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher.exec(input);

  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);

      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }

    match = multiMatcher.exec(input);
  } // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else


  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);

  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }

  return input;
}

var decodeUriComponent = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
  }

  try {
    encodedURI = encodedURI.replace(/\+/g, ' '); // Try the built in decoder first

    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }

  if (separator === '') {
    return [string];
  }

  var separatorIndex = string.indexOf(separator);

  if (separatorIndex === -1) {
    return [string];
  }

  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var queryString = createCommonjsModule(function (module, exports) {
  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;

            if (value === undefined || options.skipNull && value === null) {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[', index, ']'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };

      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null) {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[]'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };

      case 'comma':
        return function (key) {
          return function (result, value) {
            if (value === null || value === undefined || value.length === 0) {
              return result;
            }

            if (result.length === 0) {
              return [[encode(key, options), '=', encode(value, options)].join('')];
            }

            return [[result, encode(value, options)].join(',')];
          };
        };

      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null) {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [encode(key, options)]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }

  function parserForArrayFormat(options) {
    var result;

    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }

          accumulator[key][result[1]] = value;
        };

      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };

      case 'comma':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.split('').indexOf(',') > -1;
          var newValue = isArray ? value.split(',') : value;
          accumulator[key] = newValue;
        };

      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }

  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }

    return value;
  }

  function decode(value, options) {
    if (options.decode) {
      return decodeUriComponent(value);
    }

    return value;
  }

  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }

    if (typeof input === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }

    return input;
  }

  function removeHash(input) {
    var hashStart = input.indexOf('#');

    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }

    return input;
  }

  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');

    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }

    return hash;
  }

  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');

    if (queryStart === -1) {
      return '';
    }

    return input.slice(queryStart + 1);
  }

  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }

    return value;
  }

  function parse(input, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    var formatter = parserForArrayFormat(options); // Create an object with no prototype

    var ret = Object.create(null);

    if (typeof input !== 'string') {
      return ret;
    }

    input = input.trim().replace(/^[?#&]/, '');

    if (!input) {
      return ret;
    }

    var _iterator = _createForOfIteratorHelper(input.split('&')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;

        var _splitOnFirst = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='),
            _splitOnFirst2 = _slicedToArray2(_splitOnFirst, 2),
            _key = _splitOnFirst2[0],
            _value = _splitOnFirst2[1]; // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters


        _value = _value === undefined ? null : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    for (var _i2 = 0, _Object$keys = Object.keys(ret); _i2 < _Object$keys.length; _i2++) {
      var key = _Object$keys[_i2];
      var value = ret[key];

      if (typeof value === 'object' && value !== null) {
        for (var _i3 = 0, _Object$keys2 = Object.keys(value); _i3 < _Object$keys2.length; _i3++) {
          var k = _Object$keys2[_i3];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }

    if (options.sort === false) {
      return ret;
    }

    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];

      if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }

      return result;
    }, Object.create(null));
  }

  exports.extract = extract;
  exports.parse = parse;

  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }

    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none'
    }, options);
    var formatter = encoderForArrayFormat(options);
    var objectCopy = Object.assign({}, object);

    if (options.skipNull) {
      for (var _i4 = 0, _Object$keys3 = Object.keys(objectCopy); _i4 < _Object$keys3.length; _i4++) {
        var key = _Object$keys3[_i4];

        if (objectCopy[key] === undefined || objectCopy[key] === null) {
          delete objectCopy[key];
        }
      }
    }

    var keys = Object.keys(objectCopy);

    if (options.sort !== false) {
      keys.sort(options.sort);
    }

    return keys.map(function (key) {
      var value = object[key];

      if (value === undefined) {
        return '';
      }

      if (value === null) {
        return encode(key, options);
      }

      if (Array.isArray(value)) {
        return value.reduce(formatter(key), []).join('&');
      }

      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };

  exports.parseUrl = function (input, options) {
    return {
      url: removeHash(input).split('?')[0] || '',
      query: parse(extract(input), options)
    };
  };

  exports.stringifyUrl = function (input, options) {
    var url = removeHash(input.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(input.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl);
    var hash = getHash(input.url);
    var query = Object.assign(parsedQueryFromUrl, input.query);
    var queryString = exports.stringify(query, options);

    if (queryString) {
      queryString = "?".concat(queryString);
    }

    return "".concat(url).concat(queryString).concat(hash);
  };
});
var queryString_1 = queryString.extract;
var queryString_2 = queryString.parse;
var queryString_3 = queryString.stringify;
var queryString_4 = queryString.parseUrl;
var queryString_5 = queryString.stringifyUrl;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

var parse_1 = parse;
var serialize_1 = serialize;
/**
 * Module variables.
 * @private
 */

var decode$1 = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode$1;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('='); // skip things that don't look like key=value

    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim(); // quoted values

    if ('"' == val[0]) {
      val = val.slice(1, -1);
    } // only assign once


    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */


function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;

      case 'lax':
        str += '; SameSite=Lax';
        break;

      case 'strict':
        str += '; SameSite=Strict';
        break;

      case 'none':
        str += '; SameSite=None';
        break;

      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */


function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return typeof document === 'object' && typeof document.cookie === 'string';
}

function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return parse_1(cookies, options);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }

  var cleanValue = cleanupCookieValue(value);

  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {// At least we tried
    }
  } // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values


  return value;
}

function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }

  return value;
} // We can't please Rollup and TypeScript at the same time
// Only way to make both of them work


var objectAssign = require('object-assign');

var Cookies =
/** @class */
function () {
  function Cookies(cookies, options) {
    var _this = this;

    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    })["catch"](function () {});
  }

  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = parse_1(document.cookie, parseOptions);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = objectAssign({}, options, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = objectAssign({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

var CookiesContext = createContext(new Cookies());
var Provider = CookiesContext.Provider,
    Consumer = CookiesContext.Consumer;

var __extends = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var CookiesProvider =
/** @class */
function (_super) {
  __extends(CookiesProvider, _super);

  function CookiesProvider(props) {
    var _this = _super.call(this, props) || this;

    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new Cookies();
    }

    return _this;
  }

  CookiesProvider.prototype.render = function () {
    return createElement(Provider, {
      value: this.cookies
    }, this.props.children);
  };

  return CookiesProvider;
}(Component);

var __extends$1 = undefined && undefined.__extends || function () {
  var _extendStatics2 = function extendStatics(d, b) {
    _extendStatics2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics2(d, b);
  };

  return function (d, b) {
    _extendStatics2(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // Only way to make function modules work with both TypeScript and Rollup


var hoistStatics = require('hoist-non-react-statics');

function useCookies(dependencies) {
  var cookies = useContext(CookiesContext);

  if (!cookies) {
    throw new Error('Missing <CookiesProvider>');
  }

  var initialCookies = cookies.getAll();

  var _a = useState(initialCookies),
      allCookies = _a[0],
      setCookies = _a[1];

  var previousCookiesRef = useRef(allCookies);
  useEffect(function () {
    function onChange() {
      var newCookies = cookies.getAll();

      if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
        setCookies(newCookies);
      }

      previousCookiesRef.current = newCookies;
    }

    cookies.addChangeListener(onChange);
    return function () {
      cookies.removeChangeListener(onChange);
    };
  }, [cookies]);
  var setCookie = useMemo(function () {
    return cookies.set.bind(cookies);
  }, [cookies]);
  var removeCookie = useMemo(function () {
    return cookies.remove.bind(cookies);
  }, [cookies]);
  return [allCookies, setCookie, removeCookie];
}

function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }

  for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
    var dependency = dependencies_1[_i];

    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }

  return false;
}

var getUtmTrackingData = function getUtmTrackingData(cookies) {
  var trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_expid', 'utm_referrer'];
  var urlParams = queryString.parse(window.location.search);
  var foundItems = trackingKeys.filter(function (trackingKey) {
    return trackingKey in urlParams && urlParams[trackingKey].length > 0;
  }).reduce(function (foundItemsAcc, foundTrackingKey) {
    return _objectSpread2({}, foundItemsAcc, _defineProperty({}, foundTrackingKey, urlParams[foundTrackingKey]));
  }, {});

  if (Object.keys(foundItems).length === 0 && foundItems.constructor === Object) {
    var utmCookie = cookies.__k_utm;

    if (utmCookie) {
      return JSON.parse(atob(utmCookie));
    }
  }

  return foundItems;
};

var Link = React__default.forwardRef(function (_ref, ref) {
  var path = _ref.path,
      domain = _ref.domain,
      tealiumEvent = _ref.tealiumEvent,
      onClick = _ref.onClick,
      children = _ref.children,
      remainingProps = _objectWithoutProperties(_ref, ["path", "domain", "tealiumEvent", "onClick", "children"]);

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 1),
      cookies = _useCookies2[0];

  var href = "https://".concat(domain).concat(path);
  var isAppSignUp = domain.startsWith('app') && path === '/signup/create_account' || domain.startsWith('account') && path.includes('create-account'); // eslint-disable-next-line no-unused-vars

  var clickHandlerEnabled = isAppSignUp || tealiumEvent;

  var handleClick = function handleClick(event) {
    event.preventDefault();

    if (onClick) {
      onClick(event);
    }

    var hrefWithUtm = queryString.stringifyUrl({
      url: href,
      query: getUtmTrackingData(cookies)
    });
    /* if (window.utag) {
      utag.link({ tealium_event: filteredTealiumEvent }, () => {
        window.location.href = hrefWithUtm;
      });
    } else {
      window.location.href = hrefWithUtm;
    } */

    window.location.href = hrefWithUtm;
  };

  return React__default.createElement("a", _extends({
    ref: ref,
    href: href
  }, clickHandlerEnabled ? {
    onClick: handleClick
  } : onClick && {
    onClick: onClick
  }, remainingProps), children);
});
Link.propTypes = {
  path: PropTypes.string.isRequired,
  domain: PropTypes.string,
  tealiumEvent: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.any
};
Link.defaultProps = {
  domain: 'www.kabbage.com',
  tealiumEvent: '',
  onClick: null,
  children: ''
};

var useAppState = function useAppState() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSignedIn = _useState2[0],
      setIsSignedIn = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAppSubmitted = _useState4[0],
      setIsAppSubmitted = _useState4[1];

  var _useCookies = useCookies(['__k_app', '__k_signedIn']),
      _useCookies2 = _slicedToArray(_useCookies, 1),
      signedInCookies = _useCookies2[0];

  var _useCookies3 = useCookies(['__k_appSubmitted']),
      _useCookies4 = _slicedToArray(_useCookies3, 1),
      appSubmittedCookies = _useCookies4[0];

  useEffect(function () {
    var hasAppState = '__k_app' in signedInCookies && signedInCookies.__k_app;
    var isSignedInState = '__k_signedIn' in signedInCookies && signedInCookies.__k_signedIn;
    setIsSignedIn(hasAppState || isSignedInState);
  }, [signedInCookies]);
  useEffect(function () {
    var appSubmittedState = '__k_appSubmitted' in appSubmittedCookies && appSubmittedCookies.__k_appSubmitted !== undefined && appSubmittedCookies.__k_appSubmitted !== false;
    setIsAppSubmitted(appSubmittedState);
  }, [appSubmittedCookies]);
  return [isSignedIn, isAppSubmitted];
};

var useBrochureCookies = function useBrochureCookies() {
  var plp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 1),
      cookies = _useCookies2[0];

  var encodeObject = function encodeObject(obj) {
    var strObject = JSON.stringify(obj);
    return btoa(strObject);
  };

  var setCookieWrapper = function setCookieWrapper(key, value) {
    var timeLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var timeUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var expires = null;

    if (timeLength || timeLength === 0) {
      switch (timeUnit) {
        case 'years':
          expires = new Date(new Date().getTime() + timeLength * 365 * 24 * 60 * 60 * 1000);
          break;

        case 'days':
          expires = new Date(new Date().getTime() + timeLength * 24 * 60 * 60 * 1000);
          break;

        case 'minutes':
          expires = new Date(new Date().getTime() + timeLength * 60 * 1000);
          break;

        default:
          expires = new Date(new Date().getTime() + timeLength);
          break;
      }
    }

    document.cookie = "".concat(key, "=").concat(value, ";").concat(expires ? "expires=".concat(expires.toUTCString(), ";") : '', "domain=.kabbage.com;path=/");
  };

  var processUtmData = function processUtmData() {
    var latestUtmData = getUtmTrackingData(cookies);

    if (Object.keys(latestUtmData).length === 0) {
      var documentReferrer = document.referrer;
      var seoObject = {};

      if (documentReferrer.indexOf('google') > 0) {
        seoObject.utm_source = 'google';
      }

      if (documentReferrer.indexOf('bing') > 0) {
        seoObject.utm_source = 'bing';
      }

      if (documentReferrer.indexOf('yahoo') > 0) {
        seoObject.utm_source = 'yahoo';
      }

      if (Object.keys(seoObject).length !== 0) {
        seoObject.utm_medium = 'seo';
        setCookieWrapper('__k_utm', encodeObject(seoObject), 30, 'minutes');
      }
    } else if (Object.keys(latestUtmData).length !== 0) {
      setCookieWrapper('__k_utm', encodeObject(latestUtmData), 30, 'minutes');
    }
  };

  useEffect(function () {
    processUtmData();

    if (plp) {
      if (!(plp.plp.channelurl && '__k_hasCustomPlpAuth' in cookies && cookies.__k_hasCustomPlpAuth)) {
        setCookieWrapper('__k_hasCustomPlpAuth', 'kabbage.com', 7, 'days');
      }

      if (!('__k_landingPageUrl' in cookies && cookies.__k_landingPageUrl)) {
        setCookieWrapper('__k_landingPageUrl', window.location.href.split('?')[0]);
      }
    }

    if (typeof window !== "undefined") {
      var _qs$parse = queryString.parse(window.location.search),
          _qs$parse$refid = _qs$parse.refid,
          refid = _qs$parse$refid === void 0 ? null : _qs$parse$refid,
          _qs$parse$rprefid = _qs$parse.rprefid,
          rprefid = _qs$parse$rprefid === void 0 ? null : _qs$parse$rprefid,
          _qs$parse$offerId = _qs$parse.offerId,
          offerId = _qs$parse$offerId === void 0 ? null : _qs$parse$offerId,
          _qs$parse$corrdata = _qs$parse.corrdata,
          corrdata = _qs$parse$corrdata === void 0 ? null : _qs$parse$corrdata;

      if (refid) {
        setCookieWrapper('__k_refId', refid, 1, 'years');
      } else {
        var cookieCheck = '__k_refId' in cookies && cookies.__k_refId;

        if (!cookieCheck) {
          var documentReferrer = document.referrer;

          if (documentReferrer.indexOf('google') > 0) {
            setCookieWrapper('__k_refId', 'seo_google', 1, 'years');
          }

          if (documentReferrer.indexOf('bing') > 0) {
            setCookieWrapper('__k_refId', 'seo_bing', 1, 'years');
          }

          if (documentReferrer.indexOf('yahoo') > 0) {
            setCookieWrapper('__k_refId', 'seo_yahoo', 1, 'years');
          }
        }
      }

      if (rprefid) {
        setCookieWrapper('__k_rprefid', rprefid, 1, 'years');
      }

      if (offerId) {
        setCookieWrapper('__k_offerid', offerId, 1, 'years');
      }

      if (corrdata) {
        setCookieWrapper('__k_corrdata', corrdata, 1, 'years');
      }
    }
  }, []);
};

export { BodyTrackingScripts, HeadTrackingScripts, Link, useAppState, useBrochureCookies as useCookies };